import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { getMySubscription, renewMySubscription } from '../../services/subscriptionService';
import { Subscription } from '../../types/subscription';
import formStyles from '../../components/forms/Form.module.css';
import { FaCalendarCheck, FaArrowRight, FaRedo } from 'react-icons/fa';
import pageStyles from '../Page.module.css';
import Icon from '../../components/common/Icon';
const RenewSubscriptionPage: React.FC = () => {
  const [currentSubscription, setCurrentSubscription] = useState<Subscription | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  // جلب الاشتراك الحالي عند تحميل الصفحة
  useEffect(() => {
    const fetchSubscription = async () => {
      try {
        setIsLoading(true);
        const sub = await getMySubscription();
        setCurrentSubscription(sub);
      } catch (error) {
        toast.error('فشل في جلب بيانات الاشتراك الحالي.');
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchSubscription();
  }, []);

  const handleRenew = async () => {
    setIsSubmitting(true);
    const promise = renewMySubscription();

    toast.promise(promise, {
      loading: 'جاري إرسال طلب التجديد...',
      success: () => {
        navigate('/lawyer/dashboard'); // العودة إلى لوحة التحكم بعد النجاح
        return 'تم إرسال طلب التجديد بنجاح!';
      },
      error: (err: any) => {
        setIsSubmitting(false);
        return err.response?.data?.message || 'فشل في إرسال طلب التجديد.';
      },
    });
  };

  // حساب تفاصيل الاشتراك الجديد
  const getNewSubscriptionDetails = () => {
    if (!currentSubscription) return null;

    const oldEndDate = new Date(currentSubscription.end_date);
    const newStartDate = new Date(oldEndDate);
    newStartDate.setDate(oldEndDate.getDate() + 1); // يبدأ في اليوم التالي

    const newEndDate = new Date(newStartDate);
    newEndDate.setFullYear(newStartDate.getFullYear() + 1); // ينتهي بعد سنة

    return {
      startDate: newStartDate.toLocaleDateString('ar-EG'),
      endDate: newEndDate.toLocaleDateString('ar-EG'),
      fee: currentSubscription.fee, // نفترض أن الرسوم ثابتة
    };
  };

  const newDetails = getNewSubscriptionDetails();

  if (isLoading) {
    return <div className={formStyles.loading}>جاري تحميل بيانات الاشتراك...</div>;
  }

  if (!currentSubscription) {
    return (
      <div className={formStyles.pageContainer}>
        <div className={formStyles.formContainer}>
          <h2 className={formStyles.title}>تجديد الاشتراك</h2>
          <p className={formStyles.error}>لا يوجد اشتراك حالي أو سابق لتجديده.</p>
        </div>
      </div>
    );
  }

  return (
    <div className={formStyles.pageContainer}>
      <div className={formStyles.formContainer}>
        <h2 className={formStyles.title}>تأكيد تجديد الاشتراك</h2>
        <p className={formStyles.subtitle}>يرجى مراجعة تفاصيل التجديد قبل التأكيد.</p>

        <div className={formStyles.renewalDetails}>
          {/* الاشتراك الحالي */}
          <div className={formStyles.detailBox}>
            <div className={formStyles.boxHeader}>
              <Icon as={FaCalendarCheck} style={pageStyles.icon } />
              <h4>الاشتراك الحالي</h4>
            </div>
            <p><strong>تاريخ الانتهاء:</strong> {new Date(currentSubscription.end_date).toLocaleDateString('ar-EG')}</p>
            <p><strong>الحالة:</strong> {currentSubscription.status}</p>
          </div>

          <div className={formStyles.arrow}>
            <Icon as={FaArrowRight} style={pageStyles.icon } />
          </div>

          {/* الاشتراك الجديد */}
          {newDetails && (
            <div className={formStyles.detailBox}>
              <div className={formStyles.boxHeader}>
                <Icon as={FaRedo} style={pageStyles.icon } />
                <h4>الاشتراك الجديد</h4>
              </div>
              <p><strong>تاريخ البدء:</strong> {newDetails.startDate}</p>
              <p><strong>تاريخ الانتهاء:</strong> {newDetails.endDate}</p>
              <p><strong>الرسوم:</strong> {newDetails.fee} ريال</p>
            </div>
          )}
        </div>

        <button onClick={handleRenew} disabled={isSubmitting} className={formStyles.submitButton}>
          {isSubmitting ? 'جاري التأكيد...' : 'تأكيد طلب التجديد'}
        </button>
      </div>
    </div>
  );
};

export default RenewSubscriptionPage;
